import AOS from 'aos';
$(document).ready(function () {
    let page = 1;
    let range = 6;
    let loading = false;

    $(".all-posts .load-more").on("click", function () {

        if (!loading) {
            loading = true;
            let section = $(this).closest(".all-posts");
            let parent = section.find(".all-posts__box");
            let dataCategory = section.find("#select-category").val();
            let target = section.find(".all-posts__load-more");


            if (dataCategory !== '') {
                target.addClass("-loading");

                $.ajax({
                    url: myajax.url,
                    type: "post",
                    data: {
                        action: "more_posts_ajax",
                        offset: (page * range),
                        range: range,
                        postCat: dataCategory,
                    },
                    success: function (data) {
                        if (data.result) {
                            page++;

                            loading = false;
                            parent.append(data.result);

                            if (data.count <= range) {
                                section.find(".all-posts__load-more").addClass("-hidden");
                            } else {
                                section.find(".all-posts__load-more").removeClass("-hidden");
                            }
                            target.removeClass("-loading");
                            AOS.refresh()
                        } else {
                            loading = false;
                            target.removeClass("-loading");
                            parent.html('<p>Something went wrong!</p>');
                        }
                    }
                });
            }
        }
    });

    $("#select-category").select2({
        minimumResultsForSearch: -1
    }).on("change", function () {
        if (!loading) {
            loading = true;
            let postCat = $(this).val();

            let section = $(this).closest(".all-posts");
            let parent = section.find(".all-posts__box");
            let target = section.find(".all-posts__load-more");

            page = 0;


            if (postCat !== '') {
                parent.empty();
                target.addClass("-loading");

                $.ajax({
                    url: myajax.url,
                    type: "post",
                    data: {
                        action: "more_posts_ajax",
                        offset: (page * range),
                        range: range,
                        postCat: postCat,
                    },
                    success: function (data) {
                        if (data.result) {
                            page++;

                            loading = false;
                            parent.append(data.result);

                            if (data.count <= range) {
                                section.find(".all-posts__load-more").addClass("-hidden");
                            } else {
                                section.find(".all-posts__load-more").removeClass("-hidden");
                            }
                            target.removeClass("-loading");
                            AOS.refresh()
                        } else {
                            loading = false;
                            target.removeClass("-loading");
                        }
                    }
                });
            }
        }
    });

});